import React, { Component, Children } from 'react';
import styled from 'styled-components';
import { media } from './helpers';
const TitleWrap = styled.div`
	padding: 70px 20px 0px;
	${media.medium`padding: 70px 0px 0px;`};
	text-align: left;

	.inner-wrap {
		max-width: 700px;
		margin: 0px auto;
		h2 {
			margin: 0px;
			font-weight: 300;
			font-size: 30px;
			max-width: 580px;
			line-height: 40px;
		}
	}
`;

const ContentWrap = styled.div`
	padding: 30px 20px 0px;
	text-align: center;
	${media.medium`padding: 30px 0px 0px;`};
	.inner-wrap {
		max-width: 700px;
		margin: 0px auto;
		p {
			margin: 0px;
			font-weight: 300;
			text-align: left;
			line-height: 30px;
			font-family: 'Roboto', sans-serif;
		}

		a {
			font-weight: bold;
			color: #222;
			text-decoration: none;
			border-bottom: 2px solid #222;
		}
	}
`;

export const Title = ({ title }) => {
	return (
		<TitleWrap>
			<div className="inner-wrap">
				<h2>{title}</h2>
			</div>
		</TitleWrap>
	);
};

export const Content = ({ children }) => {
	return (
		<ContentWrap>
			<div className="inner-wrap">{children}</div>
		</ContentWrap>
	);
};



// WEBPACK FOOTER //
// ./src/components/Elements.js